import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { Observable, map } from "rxjs";
import { CpbSection, OfferDetailsSection, RoleDetail, RoleDetailsIds } from "talos-careers-page-library";


@Injectable()
export class OfferDetailsService {
  constructor(private httpService : HttpService) {}

  public getSectionsWithData(sections: CpbSection[], offerDetailsArray: OfferDetailsSection[]): Observable<CpbSection[]> {
    return this.httpService.getRoleDetails().pipe(
      map(data => this.mapOfferDetailsSection(offerDetailsArray, data.applicantRoleDetails)),
      map(offerDetailsSections => this.mapOfferDetailsSectionsToSectionsList(sections, offerDetailsSections))
    );
  }

  public mapOfferDetailsSection(offerDetailsArray: OfferDetailsSection[], roleDetails: RoleDetail[]): OfferDetailsSection[] {
    let fullName = '';
    let workplaceType = '';
    let additionalDetailsText = '';

    roleDetails.forEach(detail => {
      switch (detail.id) {
        case RoleDetailsIds.NAME:
          fullName = detail.value;
          break;
        case RoleDetailsIds.WORK_PLACE_TYPE:
          workplaceType = detail.value;
          break;
        case RoleDetailsIds.WORK_PLACE_NOTES:
          additionalDetailsText = detail.value === '-' ? '' : detail.value;
          break;
        default:
          break;
      }
    });
    const [firstName, ...other] = fullName.split(" ");

    const newOfferDetailsSections = offerDetailsArray.map(section => {
      return {
      ...section,
      firstName: firstName,
      fullName: fullName,
      heading: this.switchPlaceholdersToNames(section.heading, fullName, firstName),
      description: this.switchPlaceholdersToNames(section.description, fullName, firstName),
      closingText: this.switchPlaceholdersToNames(section.closingText, fullName, firstName),
      roleDetails: this.mapRoleDetails(section.roleDetails, roleDetails, workplaceType, additionalDetailsText)
    }})

    return newOfferDetailsSections as OfferDetailsSection[];
  }

  public mapOfferDetailsSectionsToSectionsList(sections: CpbSection[], offerDetailsSections: OfferDetailsSection[]) {
    const hashOfferDetailsSections = offerDetailsSections.reduce((acc: {[k:string]: OfferDetailsSection}, next: OfferDetailsSection) => {
      acc[next.id] = next;
      return acc;
    }, {})
    const newSections = sections.map(section => {
      return hashOfferDetailsSections.hasOwnProperty(section.id)
      ? {
        ...hashOfferDetailsSections[section.id]
      }
      : {
        ...section
      }
    });
    return newSections;
  }

  private mapRoleDetails(
    defaultRoleDetails: RoleDetail[],
    currentRoleDetails: RoleDetail[],
    workplaceType: string,
    additionalDetailsText: string
  ){
    const hashRoleDetailsValues = currentRoleDetails.reduce((acc: {[k:string]: string}, next: RoleDetail) => {
      acc[next.id] = next.value;
      return acc;
    }, {});
    const roleDetails = defaultRoleDetails.map(detail => {
      return detail.id === RoleDetailsIds.WORK_PLACE
        ? {
          ...detail,
          value: hashRoleDetailsValues[detail.id],
          workplaceType,
          additionalDetailsText
        }
        : {
          ...detail,
          value: hashRoleDetailsValues[detail.id]
        }
    })
    return roleDetails;
  }

  private switchPlaceholdersToNames(text: string, fullName: string, firstName: string): string {
    const firstNamePlaceholderRegExp = new RegExp(/{{EmployeeFirstName}}/, 'g');
    const fullNamePlaceholderRegExp = new RegExp(/{{EmployeeFullName}}/, 'g');

    return text.replace(
      fullNamePlaceholderRegExp,
      fullName
    ).replace(
      firstNamePlaceholderRegExp,
      firstName
    );
  };
}
